import { render, staticRenderFns } from "./entityList.vue?vue&type=template&id=97ecb4f4&"
import script from "./entityList.vue?vue&type=script&lang=js&"
export * from "./entityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports